import { Dispatch } from 'redux';
import { adminActionEnum, AdminProps } from '../reducers/admin';

export default function setAdmin(dispatch: Dispatch, payload: AdminProps) {
  dispatch({ type: adminActionEnum.SET_ADMIN, payload });
}
